import { SyntheticEvent, useState } from 'react'
import { HeaderNuevoProps } from '../HeaderContentNuevo'
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from "@mui/icons-material/Close";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, IconButton, Menu, MenuItem, Divider } from '@mui/material';
import { InfoNuevoMensajeMobile } from 'src/pages/sistema/components/mobile/InfoNuevoMensajeMobile';
import { useNavigate } from 'react-router-dom';
import SendIcon from '@mui/icons-material/Send';

export const HeaderMobileNuevo = ({ acciones, codSistema, codSistemaPrincipal, codSistemaTipo }: HeaderNuevoProps) => {
    const { saveHandler, sendHandler } = acciones

    const [anchorEl, setAnchorEl] = useState<Element | null>(null)

    const handleDropdownOpen = (event: SyntheticEvent) => {
        setAnchorEl(event.currentTarget)
    }

    const handleDropdownClose = (url?: string) => {
        // if (url) {
        //     navigate(url)
        // }
        setAnchorEl(null)
    }

    const navigation = useNavigate()

    return (
        <>
            <InfoNuevoMensajeMobile codSistemaPrincipal={codSistemaPrincipal} codSistema={codSistema} codSistemaTipo={codSistemaTipo}/>
            <Box display='flex'>
                <IconButton onClick={handleDropdownOpen}>
                    <MoreVertIcon color='primary' />
                </IconButton>
                <IconButton onClick={() => navigation('/')}>
                    <CloseIcon color='error' />
                </IconButton>
            </Box>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => handleDropdownClose()}
                sx={{ '& .MuiMenu-paper': { width: 230, mt: 4 } }}
            >
                {
                    saveHandler &&
                    <>
                        <MenuItem
                            onClick={saveHandler}
                            sx={{ py: 2, '& svg': { mr: 2, fontSize: '1.375rem', color: 'text.primary' } }}
                        >
                            <SaveIcon />
                            Guardar
                        </MenuItem>
                    </>
                }
                <Divider />
                {
                    sendHandler &&
                    <>
                        <MenuItem
                            onClick={sendHandler}
                            sx={{ py: 2, '& svg': { mr: 2, fontSize: '1.375rem', color: 'text.primary' } }}
                        >
                            <SendIcon />
                            Enviar
                        </MenuItem>
                    </>
                }
            </Menu>
        </>
    )
}
